"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuseDataClient = exports.MuseClient = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ble_utils_1 = require("../lib/ble-utils");
const c = __importStar(require("../lib/constants"));
const muse_utils_1 = require("../lib/muse-utils");
const socket_1 = require("../lib/socket");
const zip_samples_1 = require("../pipes/zip-samples");
const epoch_1 = require("../pipes/epoch");
class MuseClient extends socket_1.SocketClient {
    constructor(props) {
        super(props);
        this.enableAux = false;
        this.connectionStatus = new rxjs_1.BehaviorSubject(false);
        this.deviceName = null;
        this.controlResponse = null;
        this.telemetryData = null;
        this.gyroscopeData = null;
        this.gyroscopeReading = null;
        this.accelerometerReading = null;
        this.accelerometerData = null;
        this.eegReadings = null;
        this.ppgReadings = null;
        this.eventMarkers = null;
        this.ppgChannels = c.MUSE_PPG_CHANNELS;
        this.eegChannels = c.MUSE_EEG_CHANNELS;
        this.yDomainSettings = { eeg: [-500, 500], ppg: [-100, 100], accelerometer: [-1, 1], gyroscope: [-100, 100] };
        this.gatt = null;
        this.service = null;
        this.controlCharacteristic = null;
        this.eegCharacteristics = [];
        this.ppgCharacteristics = [];
        this.lastIndices = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
        this.lastTimestamps = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
        this.tryReconnect = false; // try to reconnect with device when connection is lost
        this.connectionStatus.subscribe((connected) => {
            if (connected) {
                this.eegEpoch = zip_samples_1.zipEEGSamples(this.eegReadings)
                    .pipe(epoch_1.epochM({
                    duration: 256,
                    interval: 256,
                    channelNames: c.MUSE_EEG_CHANNELS,
                    samplingRate: c.MUSE_EEG_SAMPLING_RATE,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.eegEpoch.connect();
                this.eegEpochFiltered = zip_samples_1.zipEEGSamples(this.eegReadings)
                    .pipe(epoch_1.epochM({
                    duration: 64,
                    interval: 64,
                    channelNames: c.MUSE_EEG_CHANNELS,
                    samplingRate: c.MUSE_EEG_SAMPLING_RATE,
                }))
                    .pipe(epoch_1.filterStreams({ nbChannels: c.MUSE_EEG_CHANNELS.length, samplingRate: c.MUSE_EEG_SAMPLING_RATE, cutoffFrequencies: [1, 45] }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.eegEpochFiltered.connect();
                this.ppgEpoch = zip_samples_1.zipPPGSamples(this.ppgReadings)
                    .pipe(epoch_1.epochM({
                    duration: 64,
                    interval: 64,
                    channelNames: c.MUSE_PPG_CHANNELS,
                    samplingRate: c.MUSE_PPG_SAMPLING_RATE,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.ppgEpoch.connect();
                //PPG Filtered for Live
                this.ppgEpochFiltered = zip_samples_1.zipPPGSamples(this.ppgReadings)
                    .pipe(epoch_1.epochM({
                    duration: 16,
                    interval: 16,
                    channelNames: c.MUSE_PPG_CHANNELS,
                    samplingRate: c.MUSE_PPG_SAMPLING_RATE,
                }))
                    .pipe(epoch_1.filterStreams({ nbChannels: c.MUSE_PPG_CHANNELS.length, samplingRate: c.MUSE_PPG_SAMPLING_RATE, cutoffFrequencies: [0.7, 3.5] }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.ppgEpochFiltered.connect();
                //GYRO
                this.gyroEpoch = zip_samples_1.zipSamples(this.gyroscopeReading, c.MUSE_GYRO_CHANNELS, c.MUSE_GYRO_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 52,
                    interval: 52,
                    channelNames: c.MUSE_GYRO_CHANNELS,
                    samplingRate: c.MUSE_GYRO_SAMPLING_RATE,
                    packetThreshold: 1,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.gyroEpoch.connect();
                //GYRO
                this.gyroEpochFiltered = zip_samples_1.zipSamples(this.gyroscopeReading, c.MUSE_GYRO_CHANNELS, c.MUSE_GYRO_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 13,
                    interval: 13,
                    channelNames: c.MUSE_GYRO_CHANNELS,
                    samplingRate: c.MUSE_GYRO_SAMPLING_RATE,
                    packetThreshold: 1,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.gyroEpochFiltered.connect();
                //ACCEL
                this.accelEpoch = zip_samples_1.zipSamples(this.accelerometerReading, c.MUSE_ACCELEROMETER_CHANNELS, c.MUSE_ACCELEROMETER_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 52,
                    interval: 52,
                    channelNames: c.MUSE_ACCELEROMETER_CHANNELS,
                    samplingRate: c.MUSE_ACCELEROMETER_SAMPLING_RATE,
                    packetThreshold: 1,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.accelEpoch.connect();
                this.accelEpochFiltered = zip_samples_1.zipSamples(this.accelerometerReading, c.MUSE_ACCELEROMETER_CHANNELS, c.MUSE_ACCELEROMETER_SAMPLING_RATE)
                    .pipe(epoch_1.epochM({
                    duration: 13,
                    interval: 13,
                    channelNames: c.MUSE_ACCELEROMETER_CHANNELS,
                    samplingRate: c.MUSE_ACCELEROMETER_SAMPLING_RATE,
                    packetThreshold: 1,
                }))
                    .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
                this.accelEpochFiltered.connect();
            }
        });
    }
    async handleControl() {
        var _a;
        this.controlCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.MUSE_GATT_ATTR_STREAM_TOGGLE));
        const controlData = (await ble_utils_1.observableCharacteristic(this.controlCharacteristic)).pipe(operators_1.map((d) => ble_utils_1.decodeResponse(new Uint8Array(d.buffer))), operators_1.share());
        this.controlResponse = muse_utils_1.decodeControl(controlData);
    }
    async handleTelemetry() {
        // const telemetryCharacteristic = await this.service?.getCharacteristic(c.MUSE_GATT_ATTR_TELEMETRY)!
        //     this.telemetryData = (await observableCharacteristic(telemetryCharacteristic))
        // decodeTelemetry   .pipe(map(pmuse-parsers)
        //       .pipe(multicast(() => new Subject<TelemetryData>())) as ConnectableObservable<TelemetryData>
        //     this.telemetryData.connect()
    }
    async handleGyroscope() {
        var _a;
        const gyroscopeCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.MUSE_GATT_ATTR_GYRO));
        this.gyroscopeReading = (await ble_utils_1.observableCharacteristic(gyroscopeCharacteristic))
            .pipe(operators_1.map((d) => {
            const eventIndex = d.getUint16(0);
            return {
                sequenceId: eventIndex,
                samples: muse_utils_1.decodeGyro(d),
                timestamp: this.getTimestampStreams(eventIndex, c.MUSE_GYRO_SAMPLING_RATE, c.MUSE_GYRO_SAMPLES_PER_READ, 3),
            };
        }))
            .pipe(operators_1.mergeMap((r) => r.samples.map((_, i) => {
            if (i == 0) {
                return { index: r.sequenceId, channel: i, timestamp: r.timestamp, samples: [r.samples[i].x, r.samples[i + 1].x, r.samples[i + 2].x] };
            }
            if (i == 1) {
                return { index: r.sequenceId, channel: i, timestamp: r.timestamp, samples: [r.samples[i - 1].y, r.samples[i].y, r.samples[i + 1].y] };
            }
            else {
                return { index: r.sequenceId, channel: i, timestamp: r.timestamp, samples: [r.samples[i - 2].z, r.samples[i - 1].z, r.samples[i].z] };
            }
        })))
            .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.gyroscopeReading.connect();
    }
    async handleAccelerometer() {
        var _a;
        const accelerometerCharacteristic = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(c.MUSE_GATT_ATTR_ACCELEROMETER));
        this.accelerometerReading = (await ble_utils_1.observableCharacteristic(accelerometerCharacteristic))
            .pipe(operators_1.map((d) => {
            const eventIndex = d.getUint16(0);
            return {
                sequenceId: eventIndex,
                samples: muse_utils_1.decodeAccel(d),
                timestamp: this.getTimestampStreams(eventIndex, c.MUSE_ACCELEROMETER_SAMPLING_RATE, c.MUSE_ACCELEROMETER_SAMPLES_PER_READ, 2),
            };
        }))
            .pipe(operators_1.mergeMap((r) => r.samples.map((_, i) => {
            if (i == 0) {
                return { index: r.sequenceId, channel: i, timestamp: r.timestamp, samples: [r.samples[i].x, r.samples[i + 1].x, r.samples[i + 2].x] };
            }
            if (i == 1) {
                return { index: r.sequenceId, channel: i, timestamp: r.timestamp, samples: [r.samples[i - 1].y, r.samples[i].y, r.samples[i + 1].y] };
            }
            else {
                return { index: r.sequenceId, channel: i, timestamp: r.timestamp, samples: [r.samples[i - 2].z, r.samples[i - 1].z, r.samples[i].z] };
            }
        })))
            .pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.accelerometerReading.connect();
    }
    getTimestampStreams(eventIndex, samplingRate, nSamples, stream) {
        const delta = 1000 * (1.0 / samplingRate) * nSamples;
        if (this.lastIndices[stream] === -1 || this.lastTimestamps[stream] === -1) {
            this.lastIndices[stream] = eventIndex;
            this.lastTimestamps[stream] = new Date().getTime() - delta;
        }
        // handle wrap around
        while (this.lastIndices[stream] - eventIndex > 0x1000) {
            eventIndex += 0x10000;
        }
        if (eventIndex === this.lastIndices[stream]) {
            return this.lastTimestamps[stream];
        }
        if (eventIndex > this.lastIndices[stream]) {
            this.lastTimestamps[stream] += delta * (eventIndex - this.lastIndices[stream]);
            this.lastIndices[stream] = eventIndex;
            return this.lastTimestamps[stream];
        }
        else {
            return this.lastTimestamps[stream] - delta * (this.lastIndices[stream] - eventIndex);
        }
    }
    async handleEEG() {
        var _a;
        this.eegCharacteristics = [];
        const eegObservables = [];
        const nChannels = this.enableAux ? c.MUSE_EEG_CHARACTERISTICS.length : 4;
        for (let channelIndex = 0; channelIndex < nChannels; channelIndex++) {
            const charId = c.MUSE_EEG_CHARACTERISTICS[channelIndex];
            const eegChar = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(charId));
            eegObservables.push((await ble_utils_1.observableCharacteristic(eegChar)).pipe(operators_1.map((d) => {
                const eventIndex = d.getUint16(0);
                return {
                    electrode: channelIndex,
                    index: eventIndex,
                    samples: muse_utils_1.decodeEEGSamples(new Uint8Array(d.buffer).subarray(2)),
                    timestamp: this.getTimestampStreams(eventIndex, c.MUSE_EEG_SAMPLING_RATE, c.MUSE_EEG_SAMPLES_PER_READ, 0),
                };
            })));
            this.eegCharacteristics.push(eegChar);
        }
        this.eegReadings = rxjs_1.merge(...eegObservables).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.eegReadings.connect();
    }
    async handlePPG() {
        var _a;
        this.ppgCharacteristics = [];
        const ppgObservables = [];
        const nChannels = c.MUSE_PPG_CHARACTERISTICS.length;
        for (let channelIndex = 0; channelIndex < nChannels; channelIndex++) {
            const charId = c.MUSE_PPG_CHARACTERISTICS[channelIndex];
            const ppgChar = await ((_a = this.service) === null || _a === void 0 ? void 0 : _a.getCharacteristic(charId));
            ppgObservables.push((await ble_utils_1.observableCharacteristic(ppgChar)).pipe(operators_1.map((d) => {
                const eventIndex = d.getUint16(0);
                return {
                    channel: channelIndex,
                    index: eventIndex,
                    samples: muse_utils_1.decodePPGSamples(new Uint8Array(d.buffer).subarray(2)),
                    timestamp: this.getTimestampStreams(eventIndex, c.MUSE_PPG_SAMPLING_RATE, c.MUSE_PPG_SAMPLES_PER_READ, 1),
                };
            })));
            this.ppgCharacteristics.push(ppgChar);
        }
        this.ppgReadings = rxjs_1.merge(...ppgObservables).pipe(operators_1.multicast(() => new rxjs_1.Subject()));
        this.ppgReadings.connect();
    }
    async sendCommand(cmd) {
        var _a;
        await ((_a = this.controlCharacteristic) === null || _a === void 0 ? void 0 : _a.writeValue(muse_utils_1.encodeCommand(cmd)));
    }
    async setPreset(preset = 'p21') {
        await this.sendCommand(preset);
    }
    async initialize(config) {
        const { device } = config || {};
        if (device) {
            this.gatt = await device.gatt.connect();
        }
        this.deviceName = this.gatt.device.name || null;
        this.service = await this.gatt.getPrimaryService(c.MUSE_SERVICE);
        // initialize data streams
        await this.handleControl();
        await this.handleTelemetry();
        await this.handleGyroscope();
        await this.handleAccelerometer();
        await this.handleEEG();
        await this.handlePPG();
        // TODO: move init to constructor, so it can be used w/o connecting headband
        this.eventMarkers = new rxjs_1.Subject();
        this.connectionStatus.next(true);
        this.lastIndices = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
        this.lastTimestamps = [-1, -1, -1, -1]; //EEG, PPG, Acc, Gyro
    }
    async start() {
        await this.pause();
        //const preset = this.enableAux ? 'p20' : 'p21'
        //await this.setPreset(preset) //Used as a preset for Muse 2016 Headset, doesn't include PPG sensor
        await this.sendCommand('s'); // This asks for control status
        await this.resume();
    }
    async stop() { }
    async pause() {
        await this.sendCommand('h');
    }
    async resume() {
        await this.sendCommand('d');
    }
    //TODO: Need to test reset function
    async reset_device() {
        await this.sendCommand('*1');
    }
    async getDeviceInfo() {
        var _a;
        const resultListener = (_a = this.controlResponse) === null || _a === void 0 ? void 0 : _a.pipe(operators_1.filter((r) => !!r.fw), operators_1.take(1)).toPromise();
        this.sendCommand('v1');
        return resultListener;
    }
    async injectMarker(value, timestamp = new Date().getTime()) {
        var _a;
        await ((_a = this.eventMarkers) === null || _a === void 0 ? void 0 : _a.next({ value, timestamp }));
    }
}
exports.MuseClient = MuseClient;
class MuseDataClient extends MuseClient {
    constructor(props) {
        super(props);
    }
    openStream(id) {
        var _a, _b, _c, _d, _e, _f;
        this.id = id;
        this.epochSub = (_a = this.eegEpoch) === null || _a === void 0 ? void 0 : _a.subscribe((e) => this.sendEpoch(id, e));
        this.ppgSub = (_b = this.ppgEpoch) === null || _b === void 0 ? void 0 : _b.subscribe((p) => this.sendPPG(id, p));
        this.accelSub = (_c = this.accelEpoch) === null || _c === void 0 ? void 0 : _c.subscribe((a) => this.sendAccel(id, a));
        this.gyroSub = (_d = this.gyroEpoch) === null || _d === void 0 ? void 0 : _d.subscribe((g) => this.sendGyro(id, g));
        this.teleSub = (_e = this.telemetryData) === null || _e === void 0 ? void 0 : _e.subscribe((t) => this.sendTele(id, t));
        this.eventSub = (_f = this.eventMarkers) === null || _f === void 0 ? void 0 : _f.subscribe((e) => this.sendEvent(id, e));
    }
    closeStream() {
        var _a, _b, _c, _d, _e, _f;
        (_a = this.epochSub) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.ppgSub) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.accelSub) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        (_d = this.gyroSub) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        (_e = this.teleSub) === null || _e === void 0 ? void 0 : _e.unsubscribe();
        (_f = this.eventSub) === null || _f === void 0 ? void 0 : _f.unsubscribe();
    }
}
exports.MuseDataClient = MuseDataClient;
//# sourceMappingURL=muse.js.map